import { render, staticRenderFns } from "./EcoExistBwRegisterContact.vue?vue&type=template&id=3ba81147&"
import script from "./EcoExistBwRegisterContact.vue?vue&type=script&lang=js&"
export * from "./EcoExistBwRegisterContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports